export const SET_CONTENT_TYPES = 'SET_CONTENT_TYPES';
export const SET_CONTENT_TYPE = 'SET_CONTENT_TYPE';
export const ADD_CONTENT_TYPE = 'ADD_CONTENT_TYPE';
export const UPDATE_CONTENT_TYPE = 'UPDATE_CONTENT_TYPE';
export const REMOVE_CONTENT_TYPE = 'REMOVE_CONTENT_TYPE';
export const CLEAR_CONTENT_TYPE = 'CLEAR_CONTENT_TYPE';
export const CLEAR_CONTENT_TYPES = 'CLEAR_CONTENT_TYPES';
